export const SET_planoS = "planoS/SET_planoS";
export const SET_plano = "planoS/SET_plano";
export const SET_PAGINATION = "planoS/SET_PAGINATION";
